import React, { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import Icon, { type Props as IconProps } from '~/components/atom/Icon';

export type Props = IconProps &
  HTMLAttributes<HTMLButtonElement> & { disabled?: boolean };

const IconOnlyButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ dataTestId, onClick, disabled, ...rest }, ref) => (
    <Container
      data-testid={dataTestId}
      onClick={onClick}
      type="button"
      ref={ref}
      $disabled={disabled}
    >
      <Icon {...rest} />
    </Container>
  ),
);

const Container = styled.button<{ $disabled?: boolean }>(
  ({ theme, $disabled }) => css`
    background-color: transparent;
    border: none;
    border-radius: ${theme.getTokens().border.radius.s};
    font-size: ${theme.fs('l')};
    cursor: pointer;
    padding: ${theme.space('xxxs')};

    display: flex;
    justify-content: center;
    align-items: center;

    transition: all 0.3s ease;

    &:hover {
      background-color: ${theme.color('tertiary', 'translucent')};
    }

    ${$disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    `}
  `,
);

export default IconOnlyButton;
